module.exports = __webpack_public_path__ + "static/media/3d-plan_general_3Shape_Color.5affdeaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general_3Shape_Color.svg
// module id = 935
// module chunks = 0